import { DateTime } from "luxon";
import { IDatePeriod } from "../../../components/datePeriodPicker/datePeriodPicker";
import { ILabelPrintScenarioViewDTO } from "../../../libs/coreapi-dto/dirs/labelPrintScenario";

export interface IInitialState {
    data: ILabelPrintScenarioViewDTO[]
    totalCount: number
    viewState: GridStateType
    selectedItem: IGridRow | undefined
    isSubmitting: boolean
    DefaultDatePeriod: IDatePeriod
}

type Action = IGetData | ISetSelectedItem | IChangeSubmitting | IRefreshData | IChangeViewState | IChangeDate | IChangeViewStateHandler

export const initialState: IInitialState = {
    data: [],
    totalCount: 0,
    viewState: 'view',
    selectedItem: undefined,
    isSubmitting: true,
    DefaultDatePeriod: {
        startDate: DateTime.now().plus({ days: -7 }),
        endDate: DateTime.now(),
    }
};

export interface IGetData {
    type: 'getData',
    payload: IInitialState
}
export interface ISetSelectedItem {
    type: 'setSelectedItem',
    payload: IGridRow | undefined
}
export interface IChangeSubmitting {
    type: 'changeSubmitting',
    payload: boolean
}
export interface IRefreshData {
    type: 'refreshData',
}
export interface IChangeViewState {
    type: 'changeViewState'
}

export interface IChangeDate {
    type: 'changeDate',
    payload: IDatePeriod
}

export interface IChangeViewStateHandler {
    type: 'changeViewStateHandler',
    payload: GridStateType
}

export function reducer(state: IInitialState = initialState, action: Action): IInitialState {
    switch (action.type) {
        case 'getData':
            return { ...state, ...action.payload, isSubmitting: false }
        case 'setSelectedItem':
            return { ...state, selectedItem: action.payload }
        case 'changeSubmitting':
            return { ...state, isSubmitting: action.payload }
        case 'refreshData':
            return { ...state, viewState: 'refresh', selectedItem: undefined }
        case 'changeViewStateHandler':
            return { ...state, viewState: action.payload }
        case 'changeDate':
            return { ...state, DefaultDatePeriod: action.payload }
        default:
            throw new Error();
    }
}